import { actionTypes } from "../Action/LoginAction";

const INITIAL_STATE = {
  login: [],
  loader: false,
  forgetpassword: [],
  changepassword: [],
  resetpassword: [],
  roleName: JSON.parse(localStorage.getItem("Admin"))?.data?.role || null,
  paymentDetail: [],
};

const LoginReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.LOADER:
      return {
        ...state,
        loader: action.loader,
      };
    case actionTypes.SET_LOGIN:
      return {
        ...state,
        login: action.login,
        loader: action.loader,
      };
    case actionTypes.SET_ROLE:
      return {
        ...state,
        roleName: action.roleName,
      };
    case actionTypes.FORGET_PASSWORD:
      return {
        ...state,
        forgetpassword: action.forgetpassword,
        loader: action.loader,
      };
    case actionTypes.CHANGE_PASSWORD:
      return {
        ...state,
        changepassword: action.changepassword,
        loader: action.loader,
      };
    case actionTypes.RESET_PASSWORD:
      return {
        ...state,
        resetpassword: action.resetpassword,
        loader: action.loader,
      };
    case actionTypes.GET_PAYMENT_DETAIL:
      return {
        ...state,
        paymentDetail: action.paymentDetail,
        loader: action.loader,
      };
    default:
      return state;
  }
};

export default LoginReducer;